import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {EntitySchemaService} from 'app/modules/core/services/entity-schema.service';
import {Feature} from 'app/modules/core/services/feature/feature';
import {ProjectService} from 'app/modules/core/services/index';
import {GuiZone, Project} from 'app/modules/core/types/api-v2/index';
import {ModelTypes} from 'app/modules/core/utils/json-schema/index';
import {GenericResourceService} from 'app/modules/features/services/generic-resource.service';
import {normalizeResourceToKey} from 'app/modules/features/shared/utils';
import {GuiZonesService} from 'app/modules/project-details/services/gui-zones.service';
import {GuiZoneExplorerAction} from 'app/modules/project-details/types';
import {ExplorerItem, TreeNodeInfo} from 'app/modules/ui-base/types';
import {BreadcrumbService} from 'app/modules/widgets/breadcrumb/services/breadcrumb.service';
import {ExplorerCustomTree} from 'app/shared/explorer-custom-tree';
import {isNullOrUndefined} from 'util';

/**
 * This component provides the data and methods to display a customized Explorer component
 * which displays a list of all the available GuiZone items of a Project
 *
 */
@Component({
  templateUrl: './gui-zones.component.html',
  styleUrls: ['./gui-zones.component.scss'],
})
export class GuiZonesComponent extends ExplorerCustomTree implements OnInit, OnDestroy {

  constructor(route: ActivatedRoute,
              resourceService: GenericResourceService,
              schemaService: EntitySchemaService,
              breadcrumbService: BreadcrumbService,
              private projectService: ProjectService,
              private guiZonesService: GuiZonesService,
              router: Router) {
    super(route, resourceService, schemaService, breadcrumbService, router);
    this.doAllowCreate = true;
    this.excludeResource(ModelTypes.GuiZone, ModelTypes.GuiZone);
    this.excludeResource(ModelTypes.GuiZone, ModelTypes.HwZone);
    this.excludeResource(ModelTypes.ProjectFeature, ModelTypes.ProjectService);
    this.excludeResource(ModelTypes.ProjectFeature, 'update');
    this.setTreeResolveDepth(4);
  }

  ngOnInit() {
    this.projectService
      .getCurrentProject()
      .filter((project: Project) => {
        const isValidProject = !isNullOrUndefined(project) && !isNullOrUndefined(project.id);
        return isValidProject;
      })
      .subscribe((project: Project) => {
        const guiZones = this.projectService.extractGuiZonesFrom(project);
        this.updateExplorerItems(guiZones);
        this.refreshNavigationalState();
      });
    this.guiZonesService.setActive();
  }

  ngOnDestroy() {
    this.guiZonesService.setInactive();
  }

  onActivateItem(nodeInfo: TreeNodeInfo) {
    this.router.navigate([nodeInfo.item.value], {relativeTo: this.route});
  }

  onAddOrCreate() {
    this.router.navigate(['new'], {relativeTo: this.route});
  }

  /**
   *
   * @param $event
   * @param {TreeNodeInfo} nodeInfo
   */
  navigateTo($event, nodeInfo: TreeNodeInfo) {
    $event.stopPropagation();
    this.navigateToTargetRoute(nodeInfo, true);

  }

  /**
   * Returns true if all current conditions, based on the provided TreeNodeInfo, are fullfiled successfuly
   * @param {TreeNodeInfo} item
   * @returns {boolean}
   */
  doDisplayNodeControls(item: TreeNodeInfo): boolean {
    const doAllow = this.doAllowNewItem(item) || this.doAllowDisplayLanding(item);
    return doAllow;
  }

  doAllowNewItem(node: TreeNodeInfo): boolean {
    return node.item.allowedActions.includes(GuiZoneExplorerAction.create);
  }

  doAllowDisplayLanding(node: TreeNodeInfo): boolean {
    return node.item.allowedActions.includes(GuiZoneExplorerAction.info);
  }

  getAllowCreateAction() {
    return GuiZoneExplorerAction.create;
  }

  getAllowInfoAction() {
    return GuiZoneExplorerAction.info;
  }

  private updateExplorerItems(guiZones: GuiZone[]) {

    guiZones.sort((a, b) => {
      let sortIndexCmp = a.sort_index - b.sort_index;
      if (sortIndexCmp !== 0) {
        return sortIndexCmp;
      }
      return a.short_name.localeCompare(b.short_name);
    });

    this.explorerItems = [];
    const explorerItems: ExplorerItem[] = [];
    const defaultOptions = {label: () => null, ...this.defaultFactoryOptions};
    const treeNodes = this
      .treeNodeFactory
      .getForRoot(guiZones, {label: () => null, ...this.defaultFactoryOptions}, [], false)
      .map((explorerItem: ExplorerItem) => {
        explorerItem.allowedActions = [this.getAllowCreateAction(), this.getAllowInfoAction()];
        return explorerItem;
      })
    ;
    this.explorerItems = treeNodes;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/gui-zone/gui-zones/gui-zones.component.ts